module.exports = __webpack_public_path__ + "static/media/YB5F14_3.1ffa0469.jpg";